import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UtcDatePipe } from './utc-date.pipe';
import { DeviceBatteryPipe } from './device-battery.pipe';
import { ContainerMsfPipe } from './container-msf.pipe';
import { AlarmTypePipe } from './alarm-type.pipe';
import { DayHourMinutePipe } from './dayHourMinute.pipe';
import { TimeFilterTypePipe } from './time-filter-type.pipe';




@NgModule({
    declarations: [
        UtcDatePipe,
        DeviceBatteryPipe,
        ContainerMsfPipe,
        AlarmTypePipe,
        TimeFilterTypePipe,
        DayHourMinutePipe
    ],
    imports: [CommonModule],
    exports: [
        UtcDatePipe,
        DeviceBatteryPipe,
        TimeFilterTypePipe,
        ContainerMsfPipe,
        AlarmTypePipe,
        DayHourMinutePipe
    ],
    providers: [],
})
export class PipesModule { };